import React from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getTranslatedText } from '../../utils/translationHelpers';

interface SearchAndFilterBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onFiltersOpen: () => void;
  activeFiltersCount: number;
  config: any;
  translations: Record<string, Record<string, string>>;
  resultCount?: number;
}

export const SearchAndFilterBar: React.FC<SearchAndFilterBarProps> = ({
  searchQuery,
  onSearchChange,
  onFiltersOpen,
  activeFiltersCount,
  config,
  translations,
  resultCount,
}) => {
  const { i18n } = useTranslation();

  const placeholderText = getTranslatedText(translations, 'search_placeholder', i18n.language) || 'Rechercher...';

  return (
    <div
      className="flex items-center gap-2 h-full px-3 border-t border-white/30"
      style={{ backgroundColor: config['major-color'] }}
    >
      <div className="flex-1 flex items-center gap-2 bg-white border border-white/60 rounded-lg px-3 py-1.5 shadow-sm">
        <Search size={15} className="shrink-0 text-gray-400" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholderText}
          className="flex-1 bg-transparent font-medium outline-none placeholder:text-gray-400 text-gray-800 min-w-0"
          style={{ fontSize: '16px' }}
        />
        {resultCount !== undefined && (
          <span className="shrink-0 text-xs text-gray-400 font-medium tabular-nums">
            {resultCount}
          </span>
        )}
        {searchQuery && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={14} />
          </button>
        )}
      </div>

      <button
        type="button"
        onClick={onFiltersOpen}
        className="relative shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-all font-semibold text-sm"
        style={
          activeFiltersCount > 0
            ? { backgroundColor: config['light-color'], color: config['major-color'], borderColor: config['light-color'] }
            : { backgroundColor: 'rgba(255,255,255,0.25)', color: config['light-color'], borderColor: 'rgba(255,255,255,0.4)' }
        }
      >
        <SlidersHorizontal size={15} />
        <span className="hidden sm:inline">{getTranslatedText(translations, 'filter_button_label', i18n.language) || 'Filtres'}</span>
        {activeFiltersCount > 0 && (
          <span
            className="absolute -top-1.5 -right-1.5 w-4 h-4 flex items-center justify-center text-xs font-bold rounded-full"
            style={{ backgroundColor: config['dark-color'], color: '#fff' }}
          >
            {activeFiltersCount}
          </span>
        )}
      </button>
    </div>
  );
};
